// extracted by mini-css-extract-plugin
export var header = "Modal-module--header--0867e";
export var modal = "Modal-module--modal--2c201";
export var modalContainer = "Modal-module--modalContainer--1e430";
export var onlyCloseIcon = "Modal-module--onlyCloseIcon--78c07";
export var title = "Modal-module--title--e2966 typography-module--responsiveTitle3--2bebc";